/**  Maintains the scroll position after clicking a link and reloading the page */
class MaintainScrollPositionComponent {
    private readonly maintainScrollKey = "maintain-scroll-data";

    /**  Initialises the MSP component */
    init() {
        this.tryLoadScrollState();

        $("a[data-maintain-scroll='true']").on("click", (event: JQuery.TriggeredEvent) => {
            var url = $(event.currentTarget).attr("href");
            this.saveScrollState(url);
        });
    }

    private saveScrollState(url: string) {
        var scrollPosition = $(window).scrollTop();
        var setting: any = {
            url: url,
            scrollPosition: scrollPosition
        };

        var json = JSON.stringify(setting);

        window.localStorage.setItem(this.maintainScrollKey, json);
    }

    private tryLoadScrollState() {
        var json = window.localStorage.getItem(this.maintainScrollKey);

        // Always remove the key
        window.localStorage.removeItem(this.maintainScrollKey);

        if (json) {
            try {
                var setting = JSON.parse(json);
                if (setting) {
                    // Ensure on URL
                    if ((window.location.pathname + window.location.search) == setting.url) {
                        // Scroll to it
                        window.scrollTo(0, setting.scrollPosition);
                    }
                }
            } catch {
                console.log("Could not load scroll position setting - ignoring. Page will load as normal.");
            }
        }
    }
}

jQuery(function () {
    let maintainScrollPosition = new MaintainScrollPositionComponent();
    maintainScrollPosition.init();
});